import clsx from 'clsx'
import { useTheme } from 'hooks'
import awsLogoWhite from '../../assets/images/aws-logo-white.png'
import awsLogo from '../../assets/images/aws-logo.png'
import logo from '../../assets/images/logo.svg'

function Footer() {
  const { theme } = useTheme()

  return (
    <footer
      className={`${clsx('text-center py-3 mt-3', {
        'text-white': theme === 'dark',
        'text-dark': theme === 'light'
      })}`}
    >
      <div className="d-flex justify-content-center align-items-center gap-4 mb-2">
        <img src={logo} alt="FinOps Center Logo" height="40" />
        <div className="vr"></div>

        {theme === 'dark' ? (
          <img src={awsLogoWhite} alt="Powered by AWS" height="40" />
        ) : (
          <img src={awsLogo} alt="Powered by AWS" height="40" />
        )}
      </div>

      <div className="text-xs">
        FinOps Center is a registered trademark of Cloud Scal3 Inc, and all rights are reserved.
      </div>
    </footer>
  )
}
export default Footer
